export default "__VITE_ASSET__Wzo3_Iei__"